import { IQBoostPromptConfig } from '@maximizer/ai/data-access';
import { MenuOptionName } from '@maximizer/core/shared/ui/enums';

export type IqBoostPage = 'main' | 'chat' | 'summary';

export interface IqPromptSelection {
  name: string;
  title: string;
  isEmailAssist: boolean;
  isDraft: boolean;
  config?: IQBoostPromptConfig;
}

export enum IqChatFrom {
  User = 'user',
  Ai = 'ai',
}

export interface IqChatMessage {
  content: string;
  from: IqChatFrom;
}

export interface IqBoostConfirmCreateCRMAction {
  key: string;
  displayText: string;
  title: string;
  description: string;
  action: MenuOptionName;
  date: string;
  openDialog: boolean;
}
